import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FlexLayoutModule } from '@angular/flex-layout';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FuseDirectivesModule } from '@fuse/directives/directives';
import { FusePipesModule } from '@fuse/pipes/pipes.module';
import { AutoFocusDirectiveDirective } from 'app/layout/components/auto-focus-directive/auto-focus-directive.directive';
import { HighlightDirective } from 'app/layout/components/HighlightDirective/HighlightDirective.directive';
import { MaskNamePipe } from 'app/layout/components/mask-name-pipe/mask-name-pipe.pipe';
import { DateTimeFormatPipe } from '../app/layout/components/date-time-format-pipe/date-time-formart-pipe.pipe';
import { CustomDatePipe } from './pipes/customDate.pipe';


@NgModule({
    declarations: [
        AutoFocusDirectiveDirective,
        HighlightDirective,
        MaskNamePipe,
        DateTimeFormatPipe,
        CustomDatePipe
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        FlexLayoutModule,
        FuseDirectivesModule,
        FusePipesModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        FlexLayoutModule,
        AutoFocusDirectiveDirective,
        HighlightDirective,
        FuseDirectivesModule,
        FusePipesModule,
        MaskNamePipe,
        CustomDatePipe,
        DateTimeFormatPipe
    ]
})
export class FuseSharedModule {
}
